import React, { Component, createRef } from "react";
import { ReactComponent as ArrowDown } from "assets/icons/arrow-down-2.svg";
import { ReactComponent as ArrowUp } from "assets/icons/arrow-up.svg";
import { withNamespaces } from "react-i18next";
import { isEqual } from "lodash";

import "component/list/CategoryGames/styles.scss";

class CategoryGames extends Component {
  constructor(props) {
    super(props);
    this.endRef = createRef();
    this.state = {
      showMore: this.props.showAll ? true : false,
      lastChildVisible: false,
    };
  }

  checklastChildVisible() {
    let lastChild = this.endRef.current.previousSibling;

    if (!lastChild) return;

    let lastChildVisible = getComputedStyle(lastChild).display !== "none";
    this.setState({
      lastChildVisible: lastChildVisible,
    });
  }

  componentDidMount() {
    this.initObserver();
    if (this.props.hasNoFilters) {
      //this.props.fetchGames();
    }

    if (!this.props.hasNextPage && this.props.games) {
      this.checklastChildVisible();
    }
  }

  initObserver() {
    if (
      "IntersectionObserver" in window &&
      "IntersectionObserverEntry" in window &&
      "intersectionRatio" in window.IntersectionObserverEntry.prototype
    ) {
      let observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.endRef.current && this.props.onReachEnd) {
                this.props.onReachEnd();
              }
            }
          });
        },
        {
          rootMargin: "0px 0px 0px 0px",
          threshold: 0.1,
        },
      );
      observer.observe(this.endRef.current);
    } else {
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (this.props.sorting && this.props.sorting !== prevProps.sorting) ||
      (this.props.sortBy && this.props.sortBy !== prevProps.sortBy) ||
      (this.props.refreshList &&
        prevProps.refreshList !== this.props.refreshList &&
        this.props.fetchGames &&
        (!this.props.isLoading && !this.props.isLoadingNext))
    ) {
      this.props.fetchGames();
    }

    if (
      !isEqual(this.props.route, prevProps.route) &&
      this.props.route &&
      this.props.hasNoFilters
    ) {
      this.props.fetchGames();
    }

    if (prevState.showMore !== this.state.showMore) {
      this.checklastChildVisible();
    }

    if (prevProps.hasNextPage !== this.props.hasNextPage) {
      this.checklastChildVisible();
    }
  }

  render() {
    const { t } = this.props;
    let ItemComponent = this.props.itemComponent;

    return (
      <div
        className={`category-games ${
          this.props.route ? this.props.route.get("rel").replace(/\./g, "") : ""
        } ${
          this.props.games && this.props.games.get("totalCount") === 0
            ? "d-none"
            : ""
        }`}
      >
        <div className="title" data-testid={this.props.titleTestId}>
          {this.props.route ? (
            this.props.route.get("name")
          ) : (
            <div className="dummy">XXXXXX XXX XXXXX</div>
          )}
        </div>
        <div
          className={`row nopadding ${
            this.state.showMore ? "show-more-games" : ""
          }`}
        >
          {this.props.games &&
            this.props.games.get("items").map((game, key) => {
              let linkDemo = game.get("links").find((link) => {
                return link.get("rel") === "launch.demo";
              });
              let linkReal = game.get("links").find((link) => {
                return link.get("rel") === "launch.real";
              });
              let linkDetails = game.get("links").find((link) => {
                return link.get("rel") === "game.details";
              });
              let gameLimit = game.get("gameLimit");

              return (
                <div className={`col col-item`} key={key}>
                  <ItemComponent
                    game={game}
                    linkDemo={linkDemo}
                    linkReal={linkReal}
                    linkDetails={linkDetails}
                    host={this.props.host}
                    key={key}
                    isMobile={this.props.isMobile}
                    onClick={(playType) => {
                      let gameId = game.get("gameId");
                      let id = game.get("id");

                      if (id && this.props.onCategoryClickHandler) {
                        return this.props.onCategoryClickHandler({
                          game,
                        });
                      }

                      if (linkReal && this.props.isOneClickPlayEnabled)
                        return this.props.onGameItemClickHandler({
                          gameId,
                          playType: linkReal.get("rel"),
                        });
                      if (linkDemo && this.props.isOneClickPlayEnabled)
                        return this.props.onGameItemClickHandler({
                          gameId,
                          playType: linkDemo.get("rel"),
                        });

                      return this.props.onGameItemClickHandler({
                        gameId,
                        playType,
                      });
                    }}
                    onShowActionClick={() => {
                      this.launchActions(game);
                    }}
                    currency={this.props.currency}
                    symbol={this.props.symbol}
                    imageFormat={this.props.imageFormat}
                    latestBroadcast={this.props.latestBroadcast}
                    isOneClickPlayEnabled={this.props.isOneClickPlayEnabled}
                    gameLimit={gameLimit}
                  />
                </div>
              );
            })}
          <div
            className={`col col-end col-item ${
              this.props.isLoading ||
              (!this.props.isLoading && !this.props.isLoadingNext)
                ? ""
                : "d-none"
            } ${this.props.hasNextPage ? "" : "d-none"}`}
            ref={this.endRef}
          >
            <ItemComponent />
          </div>
          {(!this.props.route ||
            this.props.isLoading ||
            this.props.isLoadingNext ||
            this.props.hasNextPage) &&
            [...Array(4)].map((item, key) => {
              return (
                <div className={`col col-item skeleton`} key={key}>
                  <ItemComponent key={key} isMobile={this.props.isMobile} />
                </div>
              );
            })}
        </div>
        {!this.props.showAll && !this.props.isLoading && this.props.games ? (
          <div
            className={`show-more text-center ${
              !this.state.showMore &&
              this.state.lastChildVisible &&
              !this.props.hasNextPage
                ? "d-none"
                : ""
            }`}
          >
            <button
              className="btn-more w-100"
              onClick={() => {
                this.setState({
                  showMore: !this.state.showMore,
                });
              }}
            >
              {this.state.showMore ? t("showLess") : t("showMore")}
              {this.state.showMore ? <ArrowUp /> : <ArrowDown />}
            </button>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withNamespaces("translation")(CategoryGames);
